// Destinations used by the traffic generators: ICAO code, German name, name used on frequency and the
// aerodrome reference point rounded to 0.01° (OurAirports, public domain) – only needed for directions.
import type { DestMeta } from './types';

const D = (icao: string, name: string, lat: number, lon: number, sayAs?: string): DestMeta => ({ icao, name, lat, lon, sayAs });

export const DESTINATIONS: Record<string, DestMeta> = Object.fromEntries([
  D('EDDB', 'Berlin', 52.37, 13.52, 'Berlin'),
  D('EDDF', 'Frankfurt', 50.03, 8.57, 'Frankfurt'),
  D('EDDH', 'Hamburg', 53.63, 9.99, 'Hamburg'),
  D('EDDK', 'Köln/Bonn', 50.87, 7.14, 'Cologne'),
  D('EDDL', 'Düsseldorf', 51.29, 6.77, 'Dusseldorf'),
  D('EDDM', 'München', 48.35, 11.79, 'Munich'),
  D('EDDN', 'Nürnberg', 49.50, 11.08, 'Nuremberg'),
  D('EDDS', 'Stuttgart', 48.69, 9.22, 'Stuttgart'),
  D('EDDV', 'Hannover', 52.46, 9.69, 'Hanover'),
  D('EDDW', 'Bremen', 53.05, 8.79, 'Bremen'),
  D('EDDP', 'Leipzig/Halle', 51.42, 12.24, 'Leipzig'),
  D('EDDC', 'Dresden', 51.13, 13.77, 'Dresden'),
  D('EDHI', 'Hamburg-Finkenwerder', 53.54, 9.84, 'Finkenwerder'),
  D('EDXW', 'Sylt', 54.91, 8.34, 'Sylt'),
  D('EDLP', 'Paderborn', 51.61, 8.62, 'Paderborn'),
  D('EDWE', 'Emden', 53.39, 7.23, 'Emden'),
  D('EDNY', 'Friedrichshafen', 47.67, 9.51, 'Friedrichshafen'),
  D('EHAM', 'Amsterdam', 52.31, 4.76, 'Amsterdam'),
  D('EBBR', 'Brüssel', 50.90, 4.48, 'Brussels'),
  D('ELLX', 'Luxemburg', 49.63, 6.21, 'Luxembourg'),
  D('EGLL', 'London Heathrow', 51.47, -0.46, 'London Heathrow'),
  D('EGKK', 'London Gatwick', 51.15, -0.19, 'London Gatwick'),
  D('EGSS', 'London Stansted', 51.88, 0.24, 'London Stansted'),
  D('EGGW', 'London Luton', 51.87, -0.37, 'London Luton'),
  D('EGCC', 'Manchester', 53.35, -2.27, 'Manchester'),
  D('EGNR', 'Hawarden', 53.18, -2.98, 'Hawarden'),
  D('EIDW', 'Dublin', 53.42, -6.27, 'Dublin'),
  D('LFPG', 'Paris CDG', 49.01, 2.55, 'Paris Charles de Gaulle'),
  D('LFPB', 'Paris-Le Bourget', 48.97, 2.44, 'Paris Le Bourget'),
  D('LFBO', 'Toulouse', 43.63, 1.37, 'Toulouse'),
  D('LFRS', 'Nantes', 47.15, -1.61, 'Nantes'),
  D('LFMN', 'Nizza', 43.66, 7.22, 'Nice'),
  D('LSZH', 'Zürich', 47.46, 8.55, 'Zurich'),
  D('LSGG', 'Genf', 46.24, 6.11, 'Geneva'),
  D('LOWW', 'Wien', 48.11, 16.57, 'Vienna'),
  D('LKPR', 'Prag', 50.10, 14.26, 'Prague'),
  D('EPWA', 'Warschau', 52.17, 20.97, 'Warsaw'),
  D('EKCH', 'Kopenhagen', 55.62, 12.66, 'Copenhagen'),
  D('ESSA', 'Stockholm', 59.65, 17.92, 'Stockholm'),
  D('ENGM', 'Oslo', 60.19, 11.10, 'Oslo'),
  D('EFHK', 'Helsinki', 60.32, 24.96, 'Helsinki'),
  D('LIRF', 'Rom', 41.80, 12.24, 'Rome'),
  D('LIRA', 'Rom-Ciampino', 41.80, 12.59, 'Rome Ciampino'),
  D('LIMC', 'Mailand', 45.63, 8.72, 'Milan'),
  D('LIPZ', 'Venedig', 45.51, 12.35, 'Venice'),
  D('LEMD', 'Madrid', 40.47, -3.56, 'Madrid'),
  D('LEBL', 'Barcelona', 41.30, 2.08, 'Barcelona'),
  D('LEPA', 'Palma', 39.55, 2.74, 'Palma'),
  D('LEMG', 'Málaga', 36.67, -4.50, 'Malaga'),
  D('LPPT', 'Lissabon', 38.78, -9.14, 'Lisbon'),
  D('LPFR', 'Faro', 37.01, -7.97, 'Faro'),
  D('GCLP', 'Gran Canaria', 27.93, -15.39, 'Gran Canaria'),
  D('GCTS', 'Teneriffa', 28.04, -16.57, 'Tenerife'),
  D('GCRR', 'Lanzarote', 28.95, -13.61, 'Lanzarote'),
  D('GCFV', 'Fuerteventura', 28.45, -13.86, 'Fuerteventura'),
  D('LGAV', 'Athen', 37.94, 23.94, 'Athens'),
  D('LGTS', 'Thessaloniki', 40.52, 22.97, 'Thessaloniki'),
  D('LGIR', 'Heraklion', 35.34, 25.18, 'Heraklion'),
  D('LTFM', 'Istanbul', 41.26, 28.74, 'Istanbul'),
  D('LTAI', 'Antalya', 36.90, 30.80, 'Antalya'),
  D('LTBJ', 'Izmir', 38.29, 27.16, 'Izmir'),
  D('LTFE', 'Bodrum', 37.25, 27.66, 'Bodrum'),
  D('HEGN', 'Hurghada', 27.18, 33.80, 'Hurghada'),
  D('OMDB', 'Dubai', 25.25, 55.36, 'Dubai'),
  D('OTHH', 'Doha', 25.27, 51.61, 'Doha'),
  D('KJFK', 'New York JFK', 40.64, -73.78, 'New York'),
  D('KORD', 'Chicago', 41.98, -87.90, 'Chicago'),
  D('KLAX', 'Los Angeles', 33.94, -118.41, 'Los Angeles'),
  D('CYYZ', 'Toronto', 43.68, -79.63, 'Toronto'),
  D('VHHH', 'Hongkong', 22.31, 113.91, 'Hong Kong'),
  D('ZSPD', 'Shanghai', 31.14, 121.81, 'Shanghai'),
  D('RJTT', 'Tokio Haneda', 35.55, 139.78, 'Tokyo'),
  D('VTBS', 'Bangkok', 13.69, 100.75, 'Bangkok'),
  D('FAOR', 'Johannesburg', -26.14, 28.24, 'Johannesburg'),
  D('SBGR', 'São Paulo', -23.43, -46.47, 'Sao Paulo'),
  D('LEIB', 'Ibiza', 38.87, 1.37, 'Ibiza'),
  D('LCLK', 'Larnaka', 34.88, 33.62, 'Larnaca'),
  D('LDSP', 'Split', 43.54, 16.30, 'Split'),
  D('BIKF', 'Keflavík', 63.99, -22.61, 'Keflavik'),
].map(d => [d.icao, d]));

export function dest(icao: string): DestMeta {
  const d = DESTINATIONS[icao];
  if (!d) throw new Error(`unknown destination ${icao}`);
  return d;
}
